var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarticonHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8659 1.72412L5.3396 6.32172",
    stroke: "#050505",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6125 1.72412L21.9523 6.32172",
    stroke: "#050505",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37329 9.02268C2.37329 6.89629 3.54803 6.72388 5.00756 6.72388H23.4711C24.9307 6.72388 26.1054 6.89629 26.1054 9.02268C26.1054 11.4939 24.9307 11.3215 23.4711 11.3215H5.00756C3.54803 11.3215 2.37329 11.4939 2.37329 9.02268Z",
    stroke: "#050505",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5811 16.0916V20.1719",
    stroke: "#050505",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0398 16.0916V20.1719",
    stroke: "#050505",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15308 11.4941L5.82619 21.425C6.2059 23.6548 7.11959 25.2869 10.5133 25.2869H17.6685C21.3589 25.2869 21.9047 23.7238 22.3319 21.5629L24.3254 11.4941",
    stroke: "#050505",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarticonHeader);
export default __webpack_public_path__ + "static/media/carticon-header.c7d22673107fc76f4e4d4372617d4a26.svg";
export { ForwardRef as ReactComponent };